<SettingsLayout page='settings/about' label="{"About Enafore"}">
  <div ref:node>
    <h1>{"About Enafore"}</h1>
    {@html "<p> Enafore is <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/enafore/enafore\">open-source</a> software. </p> <h2 id=\"privacy-policy\">Privacy Policy</h2> <p> Enafore does not store any personal information on its servers, including but not limited to names, email addresses, IP addresses, posts, and photos. </p> <p> Enafore is a static site hosted on Github Pages. All data is stored locally in your browser and shared with the fediverse instance(s) you connect to. </p> <p> Approximately once per day Enafore will send a request proxied through your instance so I can collect some general statistics. No personal information is sent, only your instance domain is visible. </p> <p> Post translation is powered by Google Translate via <a href=\"https://simplytranslate.org\">SimplyTranslate.org</a>. </p> <h2>Credits</h2> <p> Icons provided by <a rel=\"noopener\" target=\"_blank\" href=\"http://fontawesome.io/\">Font Awesome</a>. </p> <p> Logo thanks to \"sailboat\" by Gregor Cresnar from <a rel=\"noopener\" target=\"_blank\" href=\"https://thenounproject.com/\">the Noun Project</a>. </p> <p> Enafore is licensed under the <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/enafore/enafore/blob/main/LICENSE\">GNU Affero General Public License</a>. </p> <h2>Version</h2> <p> You are running Enafore version <code class=\"enafore-version\"></code>. </p>"}
  </div>
</SettingsLayout>
<UISettingsStyles />
<script>
  import SettingsLayout from '../../_components/settings/SettingsLayout.html'
  import UISettingsStyles from '../../_components/settings/UISettingsStyles.html'

  const version = process.env.PINAFORE_VERSION

  export default {
    oncreate () {
      for (const node of this.refs.node.querySelectorAll('.enafore-version')) {
        node.textContent = version
      }
    },
    components: {
      SettingsLayout,
      UISettingsStyles
    }
  }
</script>
